import dayjs, { Dayjs } from 'dayjs';

// Checks if the date is in past
export const disablePastDate = (current: Dayjs) => current && dayjs().diff(current, 'day') > 0;
